"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./MyNotifications.css");
const react_router_dom_1 = require("react-router-dom");
const MyNotificationsNavTabs_1 = __importDefault(require("./MyNotificationsNavTabs"));
const hook_1 = require("../../../redux/hook");
const MyNotifications = () => {
    const { token, user } = (0, hook_1.useAppSelector)((state) => state.user);
    return (react_1.default.createElement("div", { className: "dashbord-admin-component" },
        react_1.default.createElement("div", { className: "dash-admin-page-content-container mb-3" },
            react_1.default.createElement("div", { className: "container-fluid" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement("div", { className: "col-lg-12" },
                        react_1.default.createElement("div", { className: "sub-title-page-admin pb-3" }, "Notifications"),
                        react_1.default.createElement("div", { className: "row mt-5" },
                            react_1.default.createElement("div", { className: "col-lg-12 sunu-autoroute-admin-titre-page-container mb-3" },
                                react_1.default.createElement("div", { className: "admin-titre-page" }, "Mes Notifications"))),
                        react_1.default.createElement("div", { className: "pb-4 tabs__wrapper" },
                            react_1.default.createElement(MyNotificationsNavTabs_1.default, null)),
                        react_1.default.createElement("div", { className: "outlet__wrapper pricing" },
                            react_1.default.createElement(react_router_dom_1.Outlet, null))))))));
};
exports.default = MyNotifications;
